import React, { useMemo } from 'react';
import { Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import RentPaymentTable from '../rent-table';
import DepositTable from '../deposit-table';
import BasicDetail from './basic';

const PaymentPlanDetail = ({ t, paymentPlan, handleGotoPaymentPlan, property }) => {
  const depositAndFeesData = useMemo(() => {
    const { deposits, fees } = paymentPlan;
    deposits?.map((deposit, index) => {
      if (index === 0) {
        return {
          ...deposit,
          type: 'deposit',
          timestamp: Date.parse(new Date(deposit.createdAt)),
          cannotDelete: true,
        };
      } else {
        return {
          ...deposit,
          type: 'deposit',
          timestamp: Date.parse(new Date(deposit.createdAt)),
        };
      }
    });
    fees?.map(fee => ({
      ...fee,
      type: 'fee',
      timestamp: Date.parse(new Date(fee.createdAt)),
    }));
    const newArr = deposits.concat(fees).sort((a, b) => b.timestamp - a.timestamp);

    return newArr;
  }, [paymentPlan]);

  return (
    <div className="payment-plan__detail--content">
      <div className="payment-plan__detail--basic">
        <h4 className="payment-plan__detail--title">{t('basic_details')}</h4>
        <BasicDetail t={t} paymentPlan={paymentPlan} property={property} />
      </div>

      <div className="payment-plan__detail--deposit">
        <h4 className="payment-plan__detail--title">
          {t('landlord.payment.long_tail.deposit_or_fees.title')}
        </h4>
        <DepositTable
          t={t}
          isView
          dataSource={depositAndFeesData}
          currency={paymentPlan ? paymentPlan.currency : ''}
          paymentOnline={paymentPlan?.paymentOnline}
        />
      </div>

      <div className="payment-plan__detail--instalment">
        <h4 className="payment-plan__detail--title">{t('rent_payment')}</h4>
        <RentPaymentTable
          dataSource={paymentPlan?.instalments ?? []}
          paymentOnline={paymentPlan?.paymentOnline}
        />
      </div>

      <div className="payment-plan__detail--notice">
        <ExclamationCircleOutlined />

        <span className="payment-plan__detail--notice-text">
          {t('cms:cms.property.listing_management.payment_plan.detail.notice')}
        </span>

        <Button type="link" onClick={handleGotoPaymentPlan}>
          {t('global.button.go_to_check')}
        </Button>
      </div>
    </div>
  );
};

export default PaymentPlanDetail;
